// extracted by mini-css-extract-plugin
export default {"select-font":"NewSelect_select-font__ms-lE"};